import { useLayoutEffect, useRef } from 'react';

export function useInputWidthMirror(inputRef: React.RefObject<HTMLInputElement | null>) {
  const mirrorRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const mirror = document.createElement('div');
    mirror.style.cssText =
      'position:fixed;top:0;left:0;visibility:hidden;pointer-events:none;white-space:pre;z-index:-1';
    document.body.appendChild(mirror);
    mirrorRef.current = mirror;
    return () => {
      document.body.removeChild(mirror);
      mirrorRef.current = null;
    };
  }, []);

  useLayoutEffect(() => {
    const input = inputRef.current;
    const mirror = mirrorRef.current;
    if (!input || !mirror) {
      return;
    }

    if (!mirror.dataset.fontCopied) {
      const cs = getComputedStyle(input);
      mirror.style.fontFamily = cs.fontFamily;
      mirror.style.fontSize = cs.fontSize;
      mirror.style.fontWeight = cs.fontWeight;
      mirror.style.letterSpacing = cs.letterSpacing;
      mirror.dataset.fontCopied = '1';
    }

    const inputEl = input;
    const mirrorEl = mirror;

    function measure() {
      const cs = getComputedStyle(inputEl);
      mirrorEl.textContent = inputEl.value || inputEl.placeholder || '';
      const extra =
        parseFloat(cs.paddingLeft) +
        parseFloat(cs.paddingRight) +
        parseFloat(cs.borderLeftWidth) +
        parseFloat(cs.borderRightWidth);
      inputEl.style.width = `${mirrorEl.offsetWidth + extra}px`;
    }

    measure();
    inputEl.addEventListener('input', measure);
    return () => inputEl.removeEventListener('input', measure);
  });
}
